// extracted by mini-css-extract-plugin
export default {"light":"styles_light__-fAoy","banner":"styles_banner__f-Jx-","container":"styles_container__DATov","bannerText":"styles_bannerText__tuQ12"};